import React from 'react';

export interface NavigationLinkProps {
  label: string;
  href: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const NavigationLink: React.FC<NavigationLinkProps> = ({ href, label, onClick }) => {
  return (
    <a href={href} className="ckp-m-navigation__link" onClick={onClick}>
      {label}
    </a>
  );
};

export default NavigationLink;
